import { Specialties } from "src/api/types";

export const specialties: Specialties[] = ["General", "Psychiatry"] as const;
